import Translation from '../../Translation/cont/Translation'
import RadioButtonGroup from './RadioButtonGroup'
import ItemPerfomancesRadioButton from './ItemPerfomancesRadioButton'

const ItemPerfomancesButtonGroup = ({
    transIdDescription,
    buttonsConfig,
    dataKey,
    itemData,
    flyerPk = null,
    onUpdate
}) => {
    const onSetItem = value => {
        if(itemData[dataKey] !== value) {
            let data 
            if(flyerPk) {
                data = {
                    [dataKey]: value,
                    flyerPk: flyerPk
                }
            } else {
                data = {
                    [dataKey]: value
                }
            }

            onUpdate({
                ... itemData,
                ... data
            })
        }
    }

    return (
        <RadioButtonGroup
            description={<Translation id={transIdDescription}/>}
            className={'gap-20 input-' + dataKey}
        >
            {buttonsConfig.map(button => {
                const buttonId = itemData.id + button.value
                const name = button.transId ? <Translation id={button.transId}/> : button.name
                
                return (
                    <ItemPerfomancesRadioButton
                        key={buttonId}
                        id={buttonId}
                        name={itemData.id + dataKey}
                        value={button.value}
                        currentValue={itemData[dataKey]}
                        label={name}
                        onChange={onSetItem}
                    />
                )
            })}
        </RadioButtonGroup>
    )
}
export default ItemPerfomancesButtonGroup